module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/itallic-925badf243ae9771af7333b236f2ebe9.svg";